module.exports = __webpack_public_path__ + "img/blog.41498f01.png";